<template>

    <div>
        <div
            v-if="!updating"
        >
            <button
                class="btn btn-xs btn-default pull-right"
                @click="updating = true"
                v-tooltip="'Verschotten aanpassen'"
            >
                <i class="mdi mdi-pencil"></i>
                <span class="sr-only">Verschotten aanpassen</span>
            </button>
            {{ value | toCurrency }}
        </div>
        <div
            v-else
            class="flex"
        >
            <money
                class="form-control"
                :value="getProperValue()"
                @input="setProperValue($event)"
                v-bind="money"
            ></money>

            <button type="button"
                @click="updateExpenses"
                class="btn btn-info btn-xs btn-flat"
            >
                <i class="mdi mdi-content-save"></i>
            </button>
        </div>
    </div>

</template>

<script>

import axios from 'axios';
import {Money} from 'v-money';

export default {

    components: {
        Money,
    },

    data() {
        return {
            updating: false,
            money: {
                decimal: ',',
                thousands: '.',
                prefix: '€ ',
                suffix: '',
                precision: 2,
                masked: false
            },
        }
    },

    methods: {
        updateExpenses() {
            axios.patch(this.updateUrl, {expenses: this.value})
            .then(() => {
                this.$snotify.success("De verschotten zijn aangepast");
                this.updating = false;
                this.$emit('valueUpdated', this.value);
            })
            .catch(() => this.$snotify.error("Er is een fout opgetreden bij het aanpassen van de verschotten"));
        },

        getProperValue() {
            return this.value / 100;
        },

        setProperValue(newValue) {
            this.value = newValue * 100;
        },
    },

    name: "TasksUpdateExpenses",

    props: {
        value: { required: true },
        updateUrl: { required: true },
    },

}

</script>
